export default "__VITE_ASSET__Dbib$fXf__"